// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconRobotServiceMember} from '@wandb/weave/components/Icon';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TooltipDeprecated} from '@wandb/weave/components/TooltipDeprecated';
import React, {type FC, memo, useEffect} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {
  useIsAdminModeActiveAndIsNotLocalEnv,
  viewingAs,
} from '../../../util/admin';
import {useWbAgentChatContext} from '../../WbAgentChat/WbAgentChatContext';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, Wrapper} from './NavResources';

type NavAgentChatButtonProps = {
  entityName: string;
  projectName: string;
};

const NavAgentChatButtonComp: FC<NavAgentChatButtonProps> = ({
  entityName,
  projectName,
}) => {
  const {isOpen, toggle, setScope, available} = useWbAgentChatContext();
  const isAdminMode =
    useIsAdminModeActiveAndIsNotLocalEnv() || viewingAs() !== '';

  useEffect(() => {
    setScope(entityName, projectName);
  }, [entityName, projectName, setScope]);

  if (available !== true) {
    return null;
  }

  return (
    <Wrapper onClick={toggle} marginRight={7}>
      <TooltipDeprecated
        position="bottom center"
        trigger={
          <Button
            active={isOpen}
            showAdminBanner={isAdminMode}
            aria-label="WB Agent">
            <Icon />
          </Button>
        }>
        WB Agent
      </TooltipDeprecated>
    </Wrapper>
  );
};

const NavAgentChatButton = memo(NavAgentChatButtonComp);

export default NavAgentChatButton;

const Icon = styled(IconRobotServiceMember)`
  display: block;
  width: 24px;
  height: 24px;
`;
